import { IFormInvoiceInput } from "layouts/invoices/filter"
import {
    DateInvoiceCell,
    NumberInvoiceCell,
    PriceNoTaxesInvoiceCell,
    PriceWithTaxesInvoiceCell,
    StatusInvoiceCell,
} from "layouts/invoices/table/cells"
import { InvoicesTableColumnsType } from "layouts/invoices/utils/types"
import { numberComparator, stringComparator } from "lib/utils"

export const invoicesColumns: InvoicesTableColumnsType = {
    date: {
        title: "Date d'émission",
        width: "17%",
        comparatorFn: (i1, i2) => {
            return numberComparator(
                i1.issueDateTimestamp,
                i2.issueDateTimestamp
            )
        },
        cellComponent: DateInvoiceCell,
    },
    number: {
        title: "Numéro",
        width: "17%",
        comparatorFn: (i1, i2) => {
            return stringComparator(i1.number, i2.number)
        },
        cellComponent: NumberInvoiceCell,
    },
    priceNoTaxes: {
        title: "Total HT",
        width: "16%",
        comparatorFn: (i1, i2) => {
            return numberComparator(i1.TotalWithoutTax, i2.TotalWithoutTax)
        },
        cellComponent: PriceNoTaxesInvoiceCell,
    },
    priceWithTaxes: {
        title: "Total TTC",
        width: "16%",
        comparatorFn: (i1, i2) => {
            return numberComparator(i1.TotalWithTax, i2.TotalWithTax)
        },
        cellComponent: PriceWithTaxesInvoiceCell,
    },
    status: {
        title: "Statut",
        width: "18%",
        comparatorFn: (i1, i2) => {
            return stringComparator(i1.status, i2.status)
        },
        cellComponent: StatusInvoiceCell,
    },
}

export const defaultFilterValuesInvoices: IFormInvoiceInput = {
    from: -1,
    until: Number.MAX_SAFE_INTEGER,
    number: "",
    status: "Tous",
}
